import Plan from '../../models/plan.model';
import { ProcessStep } from '../../models/process-step.model';
import { Invoice } from './../../models/invoice.model';
import { StorageData } from './../storage-data';

export interface SelectedCandidateProcessStep {
    uuid: string;
    process_step: number;
    process_step_uuid: string;
    user_uuid: string;
    recruiter_uuid: string;
};

export interface Recruiters{
    uuid: string;
    name: string;
    email: string;
}

export interface CompanyState {
    lastInvoiceData: StorageData<Invoice | null, any>;
    planData: StorageData<Plan | null, any>;
    processStepsFromCompany?: StorageData<ProcessStep[], null | any>;
    candidateProcessStep?: {
        uuid: string,
        process_step: number,
        user: number
    },
    candidateProcessStepState?: {
        error: boolean,
        loading: boolean
    }
    selectedCandidatesProcessSteps?: SelectedCandidateProcessStep[];
    selectedCandidatesProcessStepsState?: {
        error: boolean,
        loading: boolean
    }
    recruiters?: Recruiters[];
    recruitersState?: {
        error: boolean,
        loading: boolean
    }
};


export const INITIAL_STATE: CompanyState = {
    lastInvoiceData: {
        loading: false,
        data: null,
        error: null
    },
    planData: {
        loading: false,
        data: null,
        error: null,
    },
    processStepsFromCompany: {
        data: [],
        loading: false,
        error: null
    },
    candidateProcessStep: {
        uuid: "",
        process_step: 0,
        user: 0,
    }, 
    candidateProcessStepState: {
        error: false,
        loading: false
    },
    selectedCandidatesProcessSteps: [],
    selectedCandidatesProcessStepsState: {
        error: false,
        loading: false
    },
    recruiters: [],
    recruitersState: {
        error: false,
        loading: false
    }
};

export enum CompanyActionTypes {
    FETCH_LAST_INVOICE = '@company/FETCH_LAST_INVOICE',
    FETCH_LAST_INVOICE_SUCCESS = '@company/FETCH_LAST_INVOICE_SUCCESS',
    FETCH_LAST_INVOICE_ERROR = '@company/FETCH_LAST_INVOICE_ERROR',
    FETCH_COMPANY_PLAN = '@company/FETCH_COMPANY_PLAN',
    FETCH_COMPANY_PLAN_SUCCESS = '@company/FETCH_COMPANY_PLAN_SUCCESS',
    FETCH_COMPANY_PLAN_ERROR = '@company/FETCH_COMPANY_PLAN_ERROR',

    FETCH_PROCESS_STEPS = '@candidate/FETCH_PROCESS_STEPS',
    FETCH_PROCESS_STEPS_SUCCESS = '@candidate/FETCH_PROCESS_STEPS_SUCCESS',
    FETCH_PROCESS_STEPS_ERROR = '@candidate/FETCH_PROCESS_STEPS_ERROR',

    FETCH_CANDIDATE_PROCESS_STEP = '@candidate/FETCH_CANDIDATE_PROCESS_STEP',
    FETCH_CANDIDATE_PROCESS_STEP_SUCCESS = '@candidate/FETCH_CANDIDATE_PROCESS_STEP_SUCCESS',
    FETCH_CANDIDATE_PROCESS_STEP_ERROR = '@candidate/FETCH_CANDIDATE_PROCESS_STEP_ERROR',

    UPDATE_CANDIDATE_PROCESS_STEP = '@candidate/UPDATE_CANDIDATE_PROCESS_STEP',
    UPDATE_CANDIDATE_PROCESS_STEP_SUCCESS = '@candidate/UPDATE_CANDIDATE_PROCESS_STEP_SUCCESS',
    UPDATE_CANDIDATE_PROCESS_STEP_ERROR = '@candidate/UPDATE_CANDIDATE_PROCESS_STEP_ERROR',

    CREATE_CANDIDATE_PROCESS_STEP = '@candidate/CREATE_CANDIDATE_PROCESS_STEP',
    CREATE_CANDIDATE_PROCESS_STEP_SUCCESS = '@candidate/CREATE_CANDIDATE_PROCESS_STEP_SUCCESS',
    CREATE_CANDIDATE_PROCESS_STEP_ERROR = '@candidate/CREATE_CANDIDATE_PROCESS_STEP_ERROR',

    FETCH_SELECTED_CANDIDATES_PROCESS_STEPS = '@candidate/FETCH_SELECTED_CANDIDATES_PROCESS_STEPS',
    FETCH_SELECTED_CANDIDATES_PROCESS_STEPS_SUCCESS = '@candidate/FETCH_SELECTED_CANDIDATES_PROCESS_STEPS_SUCCESS',
    FETCH_SELECTED_CANDIDATES_PROCESS_STEPS_ERROR = '@candidate/FETCH_SELECTED_CANDIDATES_PROCESS_STEPS_ERROR',

    FETCH_RECRUITERS = '@company/FETCH_RECRUITERS',
    FETCH_RECRUITERS_SUCCESS = '@company/FETCH_RECRUITERS_SUCCESS',
    FETCH_RECRUITERS_ERROR = '@company/FETCH_RECRUITERS_ERROR',

    UPDATE_USER_COMPANY = '@company/UPDATE_USER_COMPANY',
    UPDATE_USER_COMPANY_SUCCESS = '@company/UPDATE_USER_COMPANY_SUCCESS',
    UPDATE_USER_COMPANY_ERROR = '@company/UPDATE_USER_COMPANY_ERROR'
};
